/* Matraws — produktkort "holo-tilt": billedet vipper i 3D efter musen og
   et lysskær følger cursoren (som at vippe et holo-kort i hånden).
   Kun fine pointer; respekterer reduced-motion. */
(function () {
  if (window.__mtwPcFx) return;
  window.__mtwPcFx = 1;

  var ok = window.matchMedia
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!ok) return;

  var MAX = 13; // grader

  function bind(scope) {
    var cards = (scope || document).querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__mtwFx) continue;
      var item = card.closest('.product-card-item');
      if (item && item.getAttribute('data-mtw-available') === 'false') { card.__mtwFx = 1; continue; }
      var img = card.querySelector('.product-card-img');
      if (!img) continue;
      card.__mtwFx = 1;
      (function (card, img) {
        card.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          card.style.setProperty('--mtw-ry', ((px - 0.5) * MAX).toFixed(2) + 'deg');
          card.style.setProperty('--mtw-rx', ((0.5 - py) * MAX).toFixed(2) + 'deg');
          img.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
          img.style.setProperty('--my', (py * 100).toFixed(1) + '%');
        });
        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--mtw-rx', '0deg');
          card.style.setProperty('--mtw-ry', '0deg');
        });
      })(card, img);
    }
  }

  function init() {
    bind(document);
    document.addEventListener('shopify:section:load', function (e) { bind(e.target || document); });
    // Re-bind når kollektions-filter/søgning swapper nye kort ind
    var grid = document.getElementById('CollectionProductsParent');
    if (grid && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { bind(grid); }, 120); })
        .observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Skjul ReStock-appens 'Giv mig besked'-knap overalt UNDTAGEN hovedproduktets
   på produktsiden (vi bruger vores egen rene notify-knap på kort). Appen
   injicerer også knapper i relaterede/anbefalede produktkort på produktsiden —
   de er bredere end kortene og flyder ud over dem, så de skjules også.
   Robust mod async-injektion. */
(function () {
  if (window.__mtwHideRestock) return;
  window.__mtwHideRestock = 1;
  var onPdp = /\/products\//.test(window.location.pathname);
  var SEL = '.restock-alerts-notify-button, [class*="restock-alerts-notify-button"]';
  function sweep() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__mtwHidden) continue;
      // PDP: behold kun hovedproduktets knap — knapper inde i produktkort skjules.
      if (onPdp && el.closest && !el.closest('.product-card-item, .product-card')) continue;
      el.__mtwHidden = 1;
      el.style.setProperty('display', 'none', 'important');
    }
  }
  sweep();
  if ('MutationObserver' in window && document.body) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sweep, 60); })
      .observe(document.body, { childList: true, subtree: true });
  } else {
    var n = 0, iv = setInterval(function () { sweep(); if (++n > 40) clearInterval(iv); }, 400);
  }
})();

/* Reverse Holo som selvstændigt kort i GRIDS (kollektioner/søgesiden):
   Liquid lægger data-mtw-rh-* på kort med tilgængelig RH-Edition-variant;
   her klones kortets kolonne til en RH-tvilling med badge, RH-pris/-billede
   og ?variant=-links, indsat lige efter originalen. Rent visningslag. */
(function () {
  if (window.__mtwRhGrid) return;
  window.__mtwRhGrid = 1;

  function addVariantParam(href, vid) {
    if (!href || href.indexOf('/products/') === -1) return href;
    var hash = '';
    var hi = href.indexOf('#');
    if (hi > -1) { hash = href.slice(hi); href = href.slice(0, hi); }
    href += (href.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vid;
    return href + hash;
  }

  function makeClone(item) {
    var vid = item.getAttribute('data-mtw-rh-id');
    var price = item.getAttribute('data-mtw-rh-price');
    var im = item.getAttribute('data-mtw-rh-img');
    var col = item.parentElement;
    var cloneRoot = (col && /(^|\s|-)col-|col-\d/.test(col.className || '')) ? col : item;
    var clone = cloneRoot.cloneNode(true);
    var ci = clone.classList && clone.classList.contains('product-card-item') ? clone : clone.querySelector('.product-card-item');
    if (!ci) return null;
    ci.classList.add('mtw-rh-item');
    ci.setAttribute('data-mtw-rh-done', '1');
    ci.removeAttribute('data-mtw-rh-id'); ci.removeAttribute('data-mtw-rh-price'); ci.removeAttribute('data-mtw-rh-img');

    // Billede: RH-variantens eget foto (uden srcset, så det ikke overstyres)
    if (im) {
      var img0 = ci.querySelector('.product-card-img img');
      if (img0) { img0.src = im; img0.removeAttribute('srcset'); img0.removeAttribute('data-srcset'); img0.removeAttribute('sizes'); }
    }
    // Badge på billedet
    var wrap = ci.querySelector('.product-card-img');
    if (wrap) { var b = document.createElement('span'); b.className = 'mtw-rh-flag'; b.textContent = '✨ REVERSE HOLO'; wrap.appendChild(b); }
    // Pris: RH-fra-pris (temaets eget money-format fra Liquid); fjern evt. førpris-streg
    var priceEl = ci.querySelector('.product-price .actual-price') || ci.querySelector('.actual-price');
    if (priceEl && price) priceEl.textContent = 'Fra ' + price;
    var cmp = ci.querySelector('.product-price s, .price-item--compare, .compare-price');
    if (cmp && cmp.parentNode) cmp.parentNode.removeChild(cmp);
    // Links -> forvalgt RH-variant på produktsiden
    var links = ci.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) links[i].setAttribute('href', addVariantParam(links[i].getAttribute('href'), vid));
    var durl = ci.querySelectorAll('[data-product-url]');
    for (var j = 0; j < durl.length; j++) durl[j].setAttribute('data-product-url', addVariantParam(durl[j].getAttribute('data-product-url'), vid));
    // Sammenlign-checkbox har id/for-kollisioner i klonen — fjern den
    var cmpBox = ci.querySelector('.compare-add-button');
    if (cmpBox && cmpBox.parentNode) cmpBox.parentNode.removeChild(cmpBox);
    return { root: cloneRoot, clone: clone };
  }

  function sweep() {
    var items = document.querySelectorAll('.product-card-item[data-mtw-rh-id]:not([data-mtw-rh-done])');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      item.setAttribute('data-mtw-rh-done', '1');
      try {
        var r = makeClone(item);
        if (r && r.root.parentNode) r.root.parentNode.insertBefore(r.clone, r.root.nextSibling);
      } catch (e) { /* en enkelt klon må ikke vælte grid'et */ }
    }
  }

  function init() {
    sweep();
    if ('MutationObserver' in window && document.body) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(sweep, 80); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
